var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8668 29.1995C37.9334 28.1328 37.9334 26.5328 36.8668 25.4662L28.8668 17.4662C27.8001 16.3995 26.2001 16.3995 25.1334 17.4662L17.1334 25.4662C16.0668 26.5328 16.0668 28.1328 17.1334 29.1995C18.2001 30.2662 19.8001 30.2662 20.8668 29.1995L24.3334 25.7328V40.6662C24.3334 42.2662 25.4001 43.3328 27.0001 43.3328C28.6001 43.3328 29.6668 42.2662 29.6668 40.6662V25.7328L33.1334 29.1995C34.2001 30.2662 35.8001 30.2662 36.8668 29.1995ZM44.0668 11.8662C40.0668 2.53282 29.1334 -2.00051 19.5334 2.26615C13.4001 4.93282 9.13344 10.5328 8.33344 17.1995C2.73344 18.5328 -0.99989 24.3995 0.333444 29.9995C1.66678 34.5328 6.20011 37.9995 11.0001 37.9995H20.3334V33.7328C18.2001 34.2662 15.8001 33.4662 14.2001 31.8662C11.5334 29.1995 11.5334 24.9328 14.2001 22.5328L22.2001 14.5328C23.5334 13.1995 25.1334 12.6662 27.0001 12.6662C28.8668 12.6662 30.4668 13.4662 31.8001 14.5328L39.8001 22.5328C42.4668 25.1995 42.4668 29.4662 39.8001 31.8662C38.2001 33.4662 36.0668 34.2662 33.6668 33.7328V37.9995H40.3334C47.8001 37.9995 53.6668 32.1328 53.6668 24.6662C53.6668 18.7995 49.9334 13.7328 44.0668 11.8662Z",
    fill: "#3783FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUploadFile);
export default __webpack_public_path__ + "static/media/bulk_upload_file.f8b97b29b391640d5107289ba918c9a7.svg";
export { ForwardRef as ReactComponent };